import type { ReactNode } from 'react';
import styled from 'styled-components';

export const Wrapper = styled.div``;

export const Grid = styled.div`
  display: grid;
  gap: 18px;
  grid-template-columns: 1fr;

  @media ${({ theme }) => theme.media.desktop} {
    grid-template-columns: repeat(2, 1fr);
  }

  @media ${({ theme }) => theme.media.desktop} {
    grid-template-columns: repeat(4, 1fr);
  }
`;

export const BenefitItem = styled.div<{ children?: ReactNode }>`
  border-radius: 8px;
  border: 1px solid ${({ theme }) => theme.palette.lightGray};
  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);
  padding: 18px 12px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  text-align: center;
  gap: 8px;
  background: white;
`;

export const IconWrapper = styled.div<{ children?: ReactNode }>`
  position: relative;
  width: 60px;
  height: 60px;
  margin: 0 auto;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 20px;
  margin-bottom: 8px;
`;

export const BenefitTitle = styled.h3`
  font-size: 18px;
  font-weight: 600;
  margin-top: 0;
`;

export const Description = styled.p`
  font-size: 14px;
  line-height: 1.5;
  color: ${({ theme }) => theme.palette.gray};
`;
